export default [
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/tds-vds-register/:pageId',
        component: () => import('@/views/page/company/compliance/tds-vds-register/TdsVdsRegister.vue'),
        name: 'tds-vds-register',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/challan-register/:pageId',
        component: () => import('@/views/page/company/compliance/challan-register/ChallanRegister.vue'),
        name: 'challan-register',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/challan-register/:pageId/add',
        component: () => import('@/views/page/company/compliance/challan-register/AddChallan.vue'),
        name: 'add-challan-register',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/challan-register/:pageId/edit/:challanId',
        component: () => import('@/views/page/company/compliance/challan-register/EditChallan.vue'),
        name: 'edit-challan-register',
        meta: {
            requiresAuth: true
        }
    }
]